export default __webpack_public_path__ + "static/media/DejaVuSerif-Bold.8ca17d73.ttf";